import type {
  ISupplierProductDocument,
  ISupplierProductUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createSupplierProductDocument,
  updateDocument: updateSupplierProductDocument,
  deleteDocument: deleteSupplierProductDocument,
} = makeDocumentService<
  ISupplierProductDocument,
  ISupplierProductUploadDocument
>('/api/supplierproductdocuments', 'supplierProductDocument')
